import { FormProvider, useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { defaultFormTheme } from "../../atoms/defaultFormTheme";
import { defaultNotificationFormValues } from "./helper";
import { useFullPageLoading } from "../../atoms/full-page-loading/loadingContext";
import NotificationSelectionFields from "./fields";
import { RequestServer } from "../../utils/services";
import { APIRoutes, SETTINGS_CONFIG_TYPE } from "../../constants";
import { getUserId } from "../../utils/role";

type Props = {
    data?: typeof defaultNotificationFormValues
    handleClose: () => void
    handleDataChange: (data: any) => Promise<void>
}

export default function NotificationSelectionForm({data, handleClose,  handleDataChange }: Props) {

    const methods = useForm({ defaultValues: data || defaultNotificationFormValues });
    const { enqueueSnackbar } = useSnackbar();
    const { setLoading } = useFullPageLoading();
    
    const onSubmit = async (formData: typeof defaultNotificationFormValues) => {
        const fk_user = getUserId();
       
        if(!fk_user) {
            enqueueSnackbar("User ID not found", {
                variant: "warning"
            });
            return;
        }


        const payload = {
            fk_user,
            config_type: SETTINGS_CONFIG_TYPE.NotificationEvents,
            config_value: formData
        }

       try {               
            const response = await RequestServer(APIRoutes.SETTINGS,"POST", payload);
       
            setLoading(true);
            if(response.success) {
                localStorage.setItem("user_settings", JSON.stringify(response.data));
                await handleDataChange(formData)
                enqueueSnackbar("Notification Settings Saved Successfully", {
                    variant: "success"
                })
                handleClose()
            } else {
                enqueueSnackbar(response.message, {
                    variant: "warning"
                })
            }
       
        } catch(err: any) {
            enqueueSnackbar(err.toString() ?? "Error Occured", {
                variant: "warning"
            })
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    
    const defaultTheme = createTheme(defaultFormTheme);

    return (
    <FormProvider {...methods}>
      <ThemeProvider theme={defaultTheme}>
        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
          <NotificationSelectionFields handleClose={handleClose} />
        </form>
      </ThemeProvider>
    </FormProvider>
    )
}